import { Typography } from '@mui/material';
import { Column, RightDrawer, Spacer } from '../../components';
import { logo3NSmall } from '../../assets/png';
import { Svgs } from '../../assets/svg';
import { LearnMoreDrawerProps } from './LearnMoreAdviceAndThreeNickelsUDrawer';
import {
  SvgBulletRow,
  LearnMoreSummaryCard,
  YourLifeGoals,
  DescriptionSection,
  CloseButton,
  LearnMoreDrawerHeader,
} from './components';

export const LearnMoreAdviceDrawer: React.FC<LearnMoreDrawerProps> = ({
  drawerOpen,
  setDrawerOpen,
  pricebookBundle,
}) => {
  return (
    <RightDrawer open={drawerOpen} setOpen={setDrawerOpen}>
      <LearnMoreDrawerHeader
        paidBy={pricebookBundle.pricebook.paidBy}
        pricebookName={pricebookBundle.pricebook.pricebookName}
        logo={logo3NSmall}
      />

      <LearnMoreSummaryCard pricebookBundle={pricebookBundle} />
      <Spacer height='xs' />

      <DescriptionSection
        description={`You don’t have to choose to pay off debt OR save OR invest. 3Nickels helps you optimize
            all your goals as one integrated plan.`}
        art={<Svgs.ArtPieChart style={{ marginLeft: '20px', marginRight: '20px' }} />}
      />

      <Spacer height='xxs' />
      <Typography color='secondary' variant='p18SemiBold'>
        At a glance...
      </Typography>
      <Column style={{ padding: '0px 10px', rowGap: '20px', marginTop: '20px' }}>
        <SvgBulletRow
          art={<Svgs.BulletInvestment />}
          text={`Objective `}
          boldPostText='investment advice'
        />
        <SvgBulletRow art={<Svgs.BulletPiggyBank />} text={`Budget `} boldPostText='planner' />
        <SvgBulletRow art={<Svgs.BulletCalculator />} text={`Customizable `} boldPostText='tools' />
        <SvgBulletRow
          art={<Svgs.Bullet3nUniLessons />}
          text={`Interactive `}
          boldPostText='courses'
        />
      </Column>

      <YourLifeGoals />

      <CloseButton setDrawerOpen={setDrawerOpen} />
    </RightDrawer>
  );
};
